/* eslint-disable */
const BROWSEALL_STATE = {
	reports: [],
    recentReports: [],
    reportCount:-1,
    initialReportCount:-1
};
export default BROWSEALL_STATE;
